import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCountry, fetchRegionsByCountryId } from '../services';

// Thunk asíncrono para obtener los datos de Country desde la API
export const fetchCountryData = createAsyncThunk(
    'Country/fetchCountryData',
    async (lang = 'eng', { rejectWithValue }) => {
        try {
            const data = await fetchCountry(lang); // Llama al servicio de la API
            return data;
        } catch (error) {
            return rejectWithValue(error.message); // Manejo de errores
        }
    }
);

export const fetchRegionsByCountryIdData = createAsyncThunk(
    'Country/fetchRegionsByCountryIdData',
    async (countryId, { rejectWithValue }) => {
        try {
            const data = await fetchRegionsByCountryId(countryId);
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const STORAGE_COUNTRIES_KEY = 'rb_cached_countries';

const getInitialCountries = () => {
    try {
        if (typeof window !== 'undefined') {
            const raw = localStorage.getItem(STORAGE_COUNTRIES_KEY);
            if (raw) {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed) && parsed.length > 0) return parsed;
            }
        }
    } catch {
        // ignore
    }
    return [];
};

const CountrySlice = createSlice({
    name: 'Country',
    initialState: {
        data: getInitialCountries(),
        error: null,
        loading: false,
        regions: [], // Estado para almacenar las regiones por país
    },
    reducers: {
        // Puedes agregar más acciones sincronas si es necesario
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCountryData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCountryData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                try {
                    if (typeof window !== 'undefined' && Array.isArray(action.payload)) {
                        localStorage.setItem(STORAGE_COUNTRIES_KEY, JSON.stringify(action.payload));
                    }
                } catch {
                    // ignore
                }
            })
            .addCase(fetchCountryData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchRegionsByCountryIdData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchRegionsByCountryIdData.fulfilled, (state, action) => {
                state.loading = false;
                state.regions = action.payload; // Almacena las regiones obtenidas
            })
            .addCase(fetchRegionsByCountryIdData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Manejo de errores al obtener regiones
            });
    },
});

export default CountrySlice.reducer;
